import type * as React from 'react';
import { get } from '@Domain/Api';
import aiCostFilterOptionsFetched, {
	type AiCostFilterOptionsFetchedAction,
	type AiCostFilterOptionsFetchedPayload,
} from '@Application/AiCosts/Actions/aiCostFilterOptionsFetched';
import aiCostFilterOptionsFetchFailed, {
	type AiCostFilterOptionsFetchFailedAction,
} from '@Application/AiCosts/Actions/aiCostFilterOptionsFetchFailed';
import type FetchAiCostFilterOptions from '@Application/AiCosts/Queries/FetchAiCostFilterOptions';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = AiCostFilterOptionsFetchedAction | AiCostFilterOptionsFetchFailedAction;

export default (query: FetchAiCostFilterOptions) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const url = `${parameters.api.host}/api/accounts/${query.accountId}/ai-costs/filter-options`;

			const payload = await get<AiCostFilterOptionsFetchedPayload>(url);

			const action = aiCostFilterOptionsFetched(payload, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = aiCostFilterOptionsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
